import React from "react";
import "./Certifications.css";
import { certifications } from "../../portfolio";
import CertificationCard from "../../components/certificationCard/CertificationCard";
import FadeWrapper from "../../components/FadeWrapper/FadeWrapper";

function Certifications(props) {
  const theme = props.theme;
  return (
    <div className="main" id="certs">
      <div className="certs-header-div">
        <FadeWrapper direction="bottom" duration={2} distance={20}>
          <h1 className="certs-header" style={{ color: theme.text }}>
            Certifications, Hackathon and Volunteership
          </h1>
        </FadeWrapper>
      </div>
      <div className="certs-body-div">
        {certifications.certifications.map((cert) => {
          return <CertificationCard certificate={cert} theme={theme} />;
        })}
      </div>
    </div>
  );
}

export default Certifications;
